import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Authenticator } from '@aws-amplify/ui-react';
import type { AuthUser } from 'aws-amplify/auth';
import '@aws-amplify/ui-react/styles.css';
import App from './App';
import { configureAws } from './config/aws';
import { runtimeConfig } from './config/runtime';
import './styles.css';

let configurationError: Error | null = null;
try {
  configureAws();
} catch (error: unknown) {
  configurationError = error instanceof Error ? error : new Error(String(error));
}

function Root() {
  if (configurationError) {
    return (
      <main className="configuration-error">
        <span className="eyebrow">Configurazione</span>
        <h1>La Balanced Scorecard non può avviarsi</h1>
        <p>{configurationError.message}</p>
        <p>
          Verificare le variabili <code>VITE_COGNITO_*</code> e <code>VITE_S3_*</code>
          della build.
        </p>
      </main>
    );
  }

  if (runtimeConfig.authMode === 'disabled') {
    return <App />;
  }

  return (
    <Authenticator
      hideSignUp={!runtimeConfig.allowSignUp}
      loginMechanisms={[runtimeConfig.loginMechanism]}
    >
      {({ signOut, user }: { signOut?: () => void; user?: AuthUser }) => (
        <App user={user} signOut={signOut} />
      )}
    </Authenticator>
  );
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Elemento root non trovato.');
}

createRoot(container).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
